import { get } from 'utils/api';

export const getAllInvoice = (data) => {
  return get('/charger_bookings/invoices', data);
};
export const invoice = {
  getAllInvoice,
};
